import { Component } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@Component({
    selector: 'app-cockpit-togle-button.component',
    styleUrls: ['toggle-button.component.css'],
    templateUrl: 'toggle-button.component.html',
    imports: [MatButtonToggleModule],
})

export class CockpitToggleButton {


}